import {
  DuplicateContactException,
  ExceptionWithMessage,
} from 'shared/helpers/CustomErrors';

const FORM_PREFIX = 'CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM';

/**
 * Resolves a user-facing alert for a failed contact create/update.
 *
 * On a uniqueness failure the backend returns a 422 with
 * `{ message, attributes: [...] }`; the contacts store surfaces it as a
 * `DuplicateContactException` carrying the offending attribute names. This maps
 * that (and other thrown errors) to either an i18n key to translate or a
 * ready-to-show message, so every contact view shows the same specific error
 * instead of a generic one.
 *
 * @param {Error} error - error thrown by the contacts/update|create action
 * @returns {{ key?: string, message?: string }} `key` to translate, or `message` to show as-is
 */
export const resolveContactErrorAlert = error => {
  if (error instanceof DuplicateContactException) {
    const attributes = error.data || [];
    if (attributes.includes('email')) {
      return { key: `${FORM_PREFIX}.EMAIL_ADDRESS.DUPLICATE` };
    }
    if (attributes.includes('phone_number')) {
      return { key: `${FORM_PREFIX}.PHONE_NUMBER.DUPLICATE` };
    }
    // Duplicate on some other field (e.g. identifier): use the server's detail.
    if (error.contactErrorDetail) {
      return { message: error.contactErrorDetail };
    }
  } else if (error instanceof ExceptionWithMessage) {
    return { message: error.data };
  }
  return { key: `${FORM_PREFIX}.ERROR_MESSAGE` };
};
